import { createFeatureSelector, createSelector } from "@ngrx/store";
import { simulationLoadFeatureKey } from "./simulation-load.reducer";

export const selectSimulationLoadState = createFeatureSelector(simulationLoadFeatureKey);

export const selectSimulationLoad = createSelector(
  selectSimulationLoadState,
  (state: any) => state
);